import GlobalStyle from './styles/globals';
import { SignaturePad } from './components/SignaturePad/SignaturePad';

function App() {
  return (
    <>
      <GlobalStyle />
      <SignaturePad />
    </>
  );
}
export default App;
